import styled from "styled-components";

export const MainDivKontakt = styled.div`
  width: 100%;
  min-height: 100vh;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/burito-9d736.appspot.com/o/bghome.jpg?alt=media&token=b05e7ceb-b20d-4c5b-b586-232727b7646b");
`;
